import { render, staticRenderFns } from "./modalAddEditLabel.vue?vue&type=template&id=233afc12&scoped=true&"
import script from "./modalAddEditLabel.vue?vue&type=script&lang=js&"
export * from "./modalAddEditLabel.vue?vue&type=script&lang=js&"
import style0 from "./modalAddEditLabel.vue?vue&type=style&index=0&id=233afc12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233afc12",
  null
  
)

export default component.exports